<template>
    <div>
        <div class="common-header">
            <div class="common-header-right">
                <div class="common-header-block">支付渠道：
                    <el-select v-model="channelCodeAndPaymentWay">
                        <el-option
                                v-for="item of channelCodeAndPaymentWayOptions"
                                :key="item.label"
                                :value="item.value"
                                :label="item.label"/>
                    </el-select>
                </div>
                <!--     <div class="common-header-block">客户端渠道：
                         <el-select class="common-el-select-small" v-model="appType">
                             <el-option
                                     v-for="item of appTypeOptions"
                                     :key="item.label"
                                     :value="item.value"
                                     :label="item.label"/>
                         </el-select>
                     </div>-->
                <div class="common-header-block">状态：
                    <el-select class="common-el-select-small" v-model="status">
                        <el-option
                                v-for="item of statusOptions"
                                :key="item.label"
                                :value="item.value"
                                :label="item.label"/>
                    </el-select>
                </div>
                <div class="common-header-block">
                    <el-date-picker
                            v-model="date"
                            type="datetimerange"
                            format="yyyy-MM-dd HH:mm"
                            value-format="yyyy-MM-dd HH:mm"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"/>
                </div>
                <div class="common-header-block">
                    <el-button type="primary" @click="getList()">搜索</el-button>
                    <el-button type="success" @click="exportFunc">导出</el-button>
                </div>
            </div>
        </div>
        <strong class="common-text-item" v-text="`总充值：${payChannelRecharge.totalOrderPrice}`"></strong>
        <div class="common-table">
            <el-table
                    row-key="orderNo"
                    v-loading="loading"
                    :data="payChannelRecharge.beanList"
                    height="100%">
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="CMS账号" align="center" prop="cmsAccount"/>
                <el-table-column label="订单号" align="center" prop="orderNo"/>
                <el-table-column label="支付金额" align="center" prop="amount"/>
                <el-table-column label="客户端渠道" align="center" width="150">
                    <template slot-scope="scope">{{scope.row.appType | appTypeName}}</template>
                </el-table-column>
                <el-table-column label="状态" align="center">
                    <template slot-scope="scope">{{scope.row.status | statusName}}</template>
                </el-table-column>
                <el-table-column label="支付渠道" align="center">
                    <template slot-scope="scope">{{scope.row.channelCode |
                        channelCodeAndPaymentWay(scope.row.paymentWay)}}
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" align="center" prop="createdTime"/>
                <el-table-column label="支付时间" align="center" prop="paymentTime"/>
                <el-table-column label="银行卡号" align="center" prop="bankAccount"/>
                <el-table-column label="银行名称" align="center" prop="bankName"/>
            </el-table>
        </div>

        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="payChannelRecharge.total"
                :current-page="currentPage"
                @current-change="getList($event)"/>
    </div>
</template>
<script>
    import {mapState, mapMutations, mapActions} from 'vuex'
    import {rechargeOrderMixin} from 'mixins'

    export default {
        mixins: [rechargeOrderMixin],
        data() {
            return {
                loading: false,
                appType: 3,// 客户端终端只有web端
                status: '',// 状态
                date: null,
                channelCode: '',// 支付渠道
                paymentWay: '',// 支付方式
                channelCodeAndPaymentWay: '',
                channelCodeAndPaymentWayOptions: [
                    {
                        label: '全部',
                        value: ''
                    },
                    {
                        label: 'Upay - 银行卡',
                        value: 'Upay,4',
                    },
                    {
                        label: '吉富 - 支付宝',
                        value: 'JF,1',
                    },
                    {
                        label: '易付 - 银联快捷支付',
                        value: 'Onepay,3',
                    }
                ],
                currentPage: 1
            }
        },
        computed: {
            ...mapState('rechargeOrder', ['payChannelRecharge']),
        },
        watch: {
            channelCodeAndPaymentWay(newVal) {
                let arr = newVal.split(',');
                this.channelCode = arr[0];
                if (this.channelCodeAndPaymentWay.length > 1) {
                    this.paymentWay = arr[1]
                }else{
                    this.paymentWay = ''
                }
            }
        },
        created() {
            this.getList()
        },
        methods: {
            ...mapMutations('other', ['setStateDownloadConfig']),
            ...mapActions('rechargeOrder', ['payChannelRechargeList']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.payChannelRechargeList({
                    appType: this.appType,
                    channelCode: this.channelCode,
                    paymentWay: this.paymentWay,
                    status: this.status,
                    startTime: this.date && this.date[0] || '',
                    endTime: this.date && this.date[1] || '',
                    page: page
                }).then(() => {
                    this.loading = false;
                })
            },
            exportFunc() {
                this.setStateDownloadConfig({
                    action: '/rechargeOrders/payChannel/export',
                    info: [
                        {name: 'channelCode', value: this.channelCode},
                        {name: 'paymentWay', value: this.paymentWay},
                        {name: 'appType', value: this.appType},
                        {name: 'status', value: this.status},
                        {name: 'startTime', value: this.date ? this.date[0] : ''},
                        {name: 'endTime', value: this.date ? this.date[1] : ''},
                    ]
                });
            }
        }
    }
</script>